import { render, staticRenderFns } from "./wamserveraccess.vue?vue&type=template&id=694794c5"
import script from "./wamserveraccess.vue?vue&type=script&lang=js"
export * from "./wamserveraccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports